import PropTypes from 'prop-types'
import React from 'react'
import { noop } from 'utils'

import { ORDER } from './constants'
import RankingsBoxTableDetailsHeaderCell from './RankingsBoxTableDetailsHeaderCell'

function RankingsBoxTableDetailsHeader({ columns = [], indicator, onSort, sort = noop }) {
  return (
    <div className="rankings-box-table-details-header">
      <div className="row-wrapper flex-row">
        {columns
          .filter(column => column !== indicator)
          .map(column => (
            <RankingsBoxTableDetailsHeaderCell key={column} keyName={column} onSort={onSort} sort={sort} />
          ))}
      </div>
    </div>
  )
}

RankingsBoxTableDetailsHeader.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string),
  indicator: PropTypes.string,
  onSort: PropTypes.func,
  sort: PropTypes.shape({
    order: PropTypes.oneOf([ORDER.ASC, ORDER.DESC]),
    sortBy: PropTypes.string,
  }),
}

export default RankingsBoxTableDetailsHeader
